var Backbone = require("../../libs/backbone/backbone");
var GenericModel = require("./generic.model.ts");

var VenuesModel = GenericModel.extend(
{
    urlRoot : '/rest/api/venues',
    id : null,
    name : "",
    address : "",
    latitude : "",
    longitude : "",
    phone : "",
    fax : "",
    details : ""
});

module.exports = VenuesModel;